export default __webpack_public_path__ + "static/media/hht1_ep03_timeline_q01_a.ec825a65.png";